module.exports = __webpack_public_path__ + "static/media/playb.abd60f6f.svg";